export const selectUserPhoneNumber = (state) => state.user.userPhoneNumber;
export const selectIsNewUser = (state) => state.user.isNewUser;
export const selectUserDetails = (state) => state.user.userDetails;
export const selectPhoneNumberDialogState = (state) => state.user.phoneNumberDialog;
export const selectUserTypeFilter = (state) => state.user.userTypeFilter;